const workExperience = [
  {
    year: "2025 — Now",
    current: true,
    company: "Ubiquity Global Services Philippines, Inc.",
    roles: [{ title: "Software Engineer", date: "Jun 2025 — Present", emphasis: true }],
  },
  {
    year: "2023 — 2025",
    current: false,
    company: "Media Meter, Inc.",
    subtitle: "Promoted twice in two years — frontend to full-stack.",
    roles: [
      { index: "03", title: "Fullstack Developer", date: "Jan 2025 — May 2025", emphasis: true },
      { index: "02", title: "Senior Frontend Developer / Associate", date: "Aug 2024 — Jan 2025", emphasis: false },
      { index: "01", title: "Junior Frontend Developer", date: "Jun 2023 — Aug 2024", emphasis: false },
    ],
  },
  {
    year: "2023",
    current: false,
    company: "Lophils, Inc.",
    roles: [{ title: "Frontend Developer Intern", date: "Jan 2023 — Mar 2023", emphasis: false }],
  },
  {
    year: "2022",
    current: false,
    company: "Sandman Software Systems, Inc.",
    roles: [{ title: "Junior Software Developer Intern", date: "Sep 2022 — Nov 2022", emphasis: false }],
  },
];

export default workExperience;
